var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgUploadImages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "#3E0292",
    fillOpacity: 0.23,
    rx: 5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#030D45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "M21 12h-4.2c-1.68 0-2.52 0-3.162.327a3 3 0 0 0-1.311 1.311C12 14.28 12 15.12 12 16.8v6.4c0 1.68 0 2.52.327 3.162a3 3 0 0 0 1.311 1.311C14.28 28 15.12 28 16.8 28h6.4c1.68 0 2.52 0 3.162-.327a3 3 0 0 0 1.311-1.311C28 25.72 28 24.88 28 23.2V19"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#030D45",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5,
    d: "m12 24 4.293-4.293a1 1 0 0 1 1.414 0L21 23m0 0 2.793-2.793a1 1 0 0 1 1.414 0L28 23m-7 0 2.25 2.25M26.5 11v2.5m0 0V16m0-2.5H24m2.5 0H29"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadImages);
export default __webpack_public_path__ + "static/media/uploadImages.7908ead6abc06c32a90172281be3452c.svg";
export { ForwardRef as ReactComponent };